import { render, staticRenderFns } from "./TsDatastoreSelector.vue?vue&type=template&id=1544e2a1&"
import script from "./TsDatastoreSelector.vue?vue&type=script&lang=ts&"
export * from "./TsDatastoreSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports